import styled from 'styled-components';
import { Box } from '@rsos/base-components';

const EAGLEVIEW_MODAL_HEIGHT = '557px';
const EAGLEVIEW_MODAL_WIDTH = '680px';
const EAGLEVIEW_MAP_HEIGHT = '517px'; //  557 (modal) - 50 (header) + 10 (border bottom)
export const ModalHeaderContainer = styled(Box).attrs({
  width: '100%',
  height: '50px',
  justify: 'space-between',
  align: 'center',
  horizontal: true,
  bg: 'background',
})`
  border-radius: 5px 5px 0 0;
`;
export const ModalBody = styled(Box).attrs({
  width: '100%',
  height: '100%',
  m: 0,
  bg: 'background',
  position: 'relative',
})`
  border-radius: 5px 5px 0 0;
`;

export const CloseButton = styled(Box).attrs({
  m: '12px',
})`
  cursor: pointer;
`;

export const EagleViewMap = styled(Box).attrs({
  width: '100%',
  height: EAGLEVIEW_MAP_HEIGHT,
})``;

export const StyledCustomModal = styled(Box).attrs({
  justify: 'center',
  align: 'center',
  width: '100%',
  height: '100%',
  p: 0,
  m: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.3)',
})`
  position: fixed;
  z-index: 1;
  display: ${({ isOpened }) => (isOpened ? 'flex' : 'none')};
`;

export const ModalContainer = styled(Box).attrs({
  justify: 'center',
  width: EAGLEVIEW_MODAL_WIDTH,
  height: EAGLEVIEW_MODAL_HEIGHT,
})``;
